module.exports = __webpack_public_path__ + "static/media/Workday_Step1a_Image3a.8df983e0.jpg";